module.exports = __webpack_public_path__ + "img/design8.04e7019a.png";